import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CVPairBlock.module.css';

function CVPairBlock({ name, isDark, formik, isPrimary, onRemove, cv, coverletter, selectPrimaryPair, video_cv, ...props }) {
    const { t } = useTranslation();
    let elementClasses = [styles.occupation];

    if (onRemove) {
        elementClasses.push(styles.removable);
    }

    if (isDark) {
        elementClasses.push(styles.dark);
    }
    if (isPrimary) {
        elementClasses.push(styles.isPrimary);
    }
    return (
        <div className={styles.container}>
            <div
                className={elementClasses.join(' ')} {...props} style={{ width: '100%' }}>
                <p className={styles.label}><strong>{t('general.UI.Resume')}:</strong> <span>{cv}</span></p>
                <p className={styles.label}><strong>{t('general.UI.Cover_Letter')}:</strong> <span>{coverletter}</span></p>
                {video_cv && <p className={styles.label}><strong>{t('edit_profile.job_seeker.video_cv')}:</strong> <span>{video_cv}</span></p>}
                {onRemove && (
                    <span
                        onClick={() => onRemove('cv_Pair', props.id)}
                        className={styles.removeButton}
                        role="button"
                        aria-label="Remove occupation"
                    ></span>
                )}
            </div>
            {onRemove &&
                <div
                    className={styles.primaryIndicatorContainer}
                    onClick={() => {
                        selectPrimaryPair();
                    }}
                >
                    <div
                        className={isPrimary ? styles.primaryIndicatorActive : styles.primaryIndicator}
                    ></div>
                </div>
            }
        </div>
    );
}

export default CVPairBlock;